import { render } from "./liberarhabitaciones.vue?vue&type=template&id=1da97b01&scoped=true"
import script from "./liberarhabitaciones.vue?vue&type=script&lang=js"
export * from "./liberarhabitaciones.vue?vue&type=script&lang=js"

import "./liberarhabitaciones.vue?vue&type=style&index=0&id=1da97b01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da97b01"]])

export default __exports__